import styled from "styled-components";

const AbsolutePositionSvg = styled.svg`
  position: absolute;
  width: 0px;
  height: 0px;
`;

function Cloudy({ children, id, opacity, ...props }) {
  return (
    <>
      <AbsolutePositionSvg xmlns="http://www.w3.org/2000/svg">
        <defs>
          <filter id={id} x="0%" y="0%" width="100%" height="100%">
            <feTurbulence
              id={"cloudy_turbulence_" + id}
              type="turbulence"
              baseFrequency="0.0025"
              numOctaves="5"
              seed="10"
              result="TURBULENCE_10"
            ></feTurbulence>
            <feColorMatrix
              in="TURBULENCE_10"
              type="hueRotate"
              values="0"
              result="ANIMATED_TURBULENCE"
            >
              <animate
                attributeName="values"
                from="0"
                to="360"
                dur="5s"
                repeatCount="indefinite"
              />
            </feColorMatrix>
            <feColorMatrix
              in="ANIMATED_TURBULENCE"
              result="WISPY_TURB"
              type="saturate"
              values="0.55"
            />
            <feComponentTransfer in="WISPY_TURB" result="TRANSFER_TURB">
              <feFuncA type="linear" slope={opacity || 1.0} />
            </feComponentTransfer>
            {/* <feDisplacementMap scale="50" xChannelSelector="A" yChannelSelector="A" in2="WISPY_TURB" in="SourceGraphic" result="DISPLACED">
              <animate attributeName="scale" values="45;55;45" dur="10s" repeatCount="indefinite"></animate>
            </feDisplacementMap> */}
            <feMerge>
              <feMergeNode in="SourceGraphic"></feMergeNode>
              <feMergeNode in="TRANSFER_TURB"></feMergeNode>
            </feMerge>
          </filter>
        </defs>
      </AbsolutePositionSvg>
      <div style={{ filter: `url(#${id})` }}>{children}</div>
    </>
  );
}

export function Warped({ children, id, ...props }) {
  return (
    <>
      <AbsolutePositionSvg xmlns="http://www.w3.org/2000/svg">
        <defs>
          <filter id={id}>
            <feTurbulence
              id={"warped_turbulence_" + id}
              type="turbulence"
              baseFrequency="0.0025"
              numOctaves="8"
              seed="10"
              result="TURBULENCE_10"
            ></feTurbulence>
            <feColorMatrix
              in="TURBULENCE_10"
              type="hueRotate"
              values="0"
              result="ANIMATED_TURBULENCE"
            >
              <animate
                attributeName="values"
                from="0"
                to="360"
                dur="5s"
                repeatCount="indefinite"
              />
            </feColorMatrix>
            <feDisplacementMap
              scale="50"
              xChannelSelector="A"
              yChannelSelector="A"
              in2="WISPY_TURB"
              in="SourceGraphic"
              result="DISPLACED"
            >
              <animate
                attributeName="scale"
                values="45;55;45"
                dur="10s"
                repeatCount="indefinite"
              ></animate>
            </feDisplacementMap>
          </filter>
        </defs>
      </AbsolutePositionSvg>
      <div style={{ filter: `url(#${id})` }}>{children}</div>
    </>
  );
}

export default Cloudy;

// <animate
//   id={"#animate_cloudy_turbulence_" + id}
//   href={"#cloudy_turbulence_" + id}
//   attributeName="seed"
//   repeatCount="indefinite"
//   from="1"
//   to="4"
//   by="0.1"
//   calcMode="linear"
//   dur="10s"
//   fill="freeze"
// />
